import { gql } from "@apollo/client";

export const DELETE_ZIPCODE_GEOFENCE = gql`
    mutation DeleteZipcodeGeofence($id: Long!) {
        deleteZipcodeGeofence(id: $id)
    }
`;

export interface DeleteZipcodeGeofenceInput {
    id: number;
}

export interface DeleteZipcodeGeofenceResponse {
    deleteZipcodeGeofence: boolean;
}
